/* eslint-disable no-underscore-dangle */
import moment from 'moment-timezone';
import i18n from 'i18next';

const getUnixTime = date => Math.trunc(date.getTime() / 1000);

if (!Date.now) Date.now = () => new Date();
Date.time = () => getUnixTime(new Date());

export const setPreferredTimezone = (timezone) => {
  if (timezone) {
    moment.tz.setDefault(timezone);
  } else {
    moment.tz.setDefault(moment.tz.guess());
  }
};

export const getPreferredTimezone = (user, account) => {
  let timezone = null;
  if (user.use_account_timezone && account.preferences && account.preferences.timezone) {
    timezone = account.preferences.timezone.name;
  }
  return timezone;
};

export function getRelativeDuration(timestamp) {
  if (!timestamp) {
    return null;
  }
  const timeDiff = moment(timestamp) - moment(new Date());
  let result = moment.duration(timeDiff, 'milliseconds').humanize(true);
  // English: "5 minutes ago" → "5 minutes" for templates like "since {{duration}}"
  result = result.replace(' ago', '');
  result = result.replace('in ', '');
  result = result.replace(/前$/, '');
  return result;
}

export function timeSince(timestamp) {
  if (!timestamp) {
    return '--';
  }
  const duration = getRelativeDuration(timestamp);
  return i18n.t('common.timeSince', {
    duration,
    defaultValue: `since ${duration}`,
  });
}

export function localTimeString(timestamp) {
  if (!timestamp) {
    return '                --';
  }
  const time = moment(timestamp);
  // return time.format('MM.DD.YYYY hh:mm A'); --> in design
  return time.format('MMM Do, YYYY h:mm A, z');
}
